import React from 'react';
import { is } from 'ramda';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import MinusIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';

import { TextField, InputAdornment, Box, Typography } from '@material-ui/core';
import CustomNumberInput from './components/CustomNumberInput';

import useStyles from './useStyles';

const PercentInputField = props => {
  const { value, onChange, stepDiff, max, min, label } = props;
  const classes = useStyles();

  const handleIncrease = () => {
    const increasedValue = value + stepDiff;
    const newValue = increasedValue > max ? max : increasedValue;
    onChange(newValue);
  };

  const handleDecrease = () => {
    const decreasedValue = value - stepDiff;
    const newValue = decreasedValue < min ? min : decreasedValue;
    onChange(newValue);
  };

  const handleChange = newValue => {
    if (is(Number, newValue) || newValue < 0) return;
    onChange(newValue);
  };

  return (
    <Box>
      <Typography className={classes.label} variant="subtitle1" color="secondary">
        {label}
      </Typography>
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MinusIcon className={classes.iconButton} onClick={handleDecrease} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <AddIcon className={classes.iconButton} onClick={handleIncrease} />
            </InputAdornment>
          ),
          inputComponent: CustomNumberInput,
        }}
        onChange={handleChange}
        variant="outlined"
        className={classes.field}
        value={value}
      />
    </Box>
  );
};

PercentInputField.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  stepDiff: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  label: PropTypes.string,
};

PercentInputField.defaultProps = {
  label: '',
};

export default PercentInputField;



// WEBPACK FOOTER //
// ./src/sharedComponents/PercentInputField/PercentInputField.js